<mat-card style="padding-bottom: 10px;" id="transaction-search">
  <app-matspinner *ngIf="isLoading"></app-matspinner>
  <mat-card-header>
    <mat-card-title class="title">Transaction Search</mat-card-title>
  </mat-card-header>
  <mat-divider  class="divider"></mat-divider>
  <mat-card-content>
    <br>
    <!-- <div class="container"> -->
      <form [formGroup]="form" (ngSubmit)="submitForm()">
        <mat-accordion>
          <mat-expansion-panel (opened)="panelOpenState = true"
          (closed)="panelOpenState = false" [expanded]=true>
      <mat-expansion-panel-header style="height: 30px;">
      </mat-expansion-panel-header>
      <div class="container">
        <div class="row form-row">
          <div class="col-md-2">
            <label class="lbl_fld">Message ID</label>
          </div>
          <div class="col-md-4">
            <mat-form-field class="ffs" appearance="outline" subscriptSizing="dynamic">
              <input
                type="text"
                name="MessageId"
                (keyup)="onInputkeyup($event)"
                matInput
                formControlName="MessageId"
                placeholder="Message ID (Max length is 35 characters)"
                ngDefaultControl>
              <mat-error>
                {{errorMessageForMessageId}}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-2 right-shift">
            <label class="lbl_fld">Relates to Message ID</label>
          </div>
          <div class="col-md-4">
            <mat-form-field class="ffs" appearance="outline" subscriptSizing="dynamic">
              <input type="text" name="RelatesToMessageId" (keyup)='onInputkeyup($event)' matInput formControlName="RelatesToMessageId" placeholder="Relates to Message ID (Max length is 35 characters)" ngDefaultControl>
              <mat-error>
                {{errorMessageForRelatesToMessageId}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <mat-divider class="divider"></mat-divider>
        <div class="row form-row">
          <div class="col-md-2">
            <label class="lbl_fld">Pharmacy Chain/Vendor</label>
          </div>
          <div class="col-md-4">
            <mat-form-field class="ffs" appearance="outline" subscriptSizing="dynamic">
              <input type="text"
                name="PharmacyVendor"
                (keyup)='onInputkeyup($event)'
                formControlName="PharmacyVendor"
                placeholder="Select Vendor"
                aria-label="Pharmacy Chain/Vendor"
                matInput
                [matAutocomplete]="autovendor" ngDefaultControl>
              <mat-autocomplete #autovendor="matAutocomplete" (optionSelected)='onChange($event)' [displayWith]="displayTextForVendor"
                id="PharmacyVendor">
                <mat-option *ngFor="let vendor of filteredOptions | async" [value]="vendor">{{vendor.PharmacyName}}</mat-option>
              </mat-autocomplete>
              <mat-error>Invalid pharmacy/vendor entered</mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-2 right-shift">
            <label class="lbl_fld">Pharmacy NCPDP ID</label>
          </div>
          <div class="col-md-4">
            <mat-form-field class="ffs" appearance="outline" subscriptSizing="dynamic">
              <input (keyup)='onInputkeyup($event)' matInput name="PharmacyNcpdpid" formControlName="PharmacyNcpdpid" placeholder="Pharmacy NCPDP ID (Max length is 7 characters)" ngDefaultControl>
              <mat-error>
                {{errorMessageForPharmacyNcpdpid}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row form-row">
          <div class="col-md-2">
            <label class="lbl_fld">Message Type</label>
          </div>
          <div class="col-md-4">
            <mat-form-field class="ffs ddl" appearance="outline" subscriptSizing="dynamic">
              <mat-select (selectionChange)='onChange($event)' formControlName="MessageType" placeholder="Select Message Type" ngDefaultControl id="MessageType">
                <mat-option *ngFor="let messageType of messageTypeList" [value]="messageType.Id">{{messageType.Name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-2 right-shift">
            <label class="lbl_fld">Status</label>
          </div>
          <div class="col-md-4">
            <mat-form-field class="ffs ddl" appearance="outline" subscriptSizing="dynamic">
              <mat-select (selectionChange)='onChange($event)' formControlName="Status" placeholder="Select Status" ngDefaultControl id="Status">
                <mat-option *ngFor="let status of statusList" [value]="status.StatusName">{{status.StatusName}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row form-row">
          <div class="col-md-2">
            <label class="lbl_fld">Patient Last Name</label>
          </div>
          <div class="col-md-4">
            <mat-form-field class="ffs" appearance="outline" subscriptSizing="dynamic">
              <input name="PatientLastName" (keyup)='onInputkeyup($event)' matInput formControlName="PatientLastName" placeholder="Patient Last Name (Max length is 35 characters)" ngDefaultControl>
              <mat-error>
                {{errorMessageForPharmacyLastname}}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-2 right-shift">
            <label class="lbl_fld">Patient Date of Birth</label>
          </div>
          <div class="col-md-4">
            <mat-form-field class="ffs" appearance="outline" subscriptSizing="dynamic">
              <input name="PatientDateOfBirth" [max]="today" (keyup)='onInputkeyup($event)' (dateChange)="onDobDateSelect($event)" formControlName="PatientDateOfBirth" placeholder="MM/DD/YYYY" matInput [matDatepicker]="dobdatepicker" ngDefaultControl>
              <mat-datepicker-toggle matIconSuffix [for]="dobdatepicker"></mat-datepicker-toggle>
              <mat-datepicker #dobdatepicker></mat-datepicker>
              <mat-error>{{errorMessageForPatientDOB}}</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row form-row">
          <div class="col-md-2">
            <label class="lbl_fld">Type</label>
          </div>
          <div class="col-md-4">
            <mat-form-field class="ffs ddl" appearance="outline" subscriptSizing="dynamic">
              <mat-select (selectionChange)='onChange($event)' formControlName="Species" placeholder="Select Species" ngDefaultControl id="Species">
                <mat-option *ngFor="let species of speciesList" [value]="species.SpeciesName">{{species.SpeciesName}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <mat-divider class="divider"></mat-divider>
        <div class="row form-row">
          <div class="col-md-2">
            <label class="lbl_fld">Begin Date</label>
          </div>
          <div class="col-md-4">
            <mat-form-field class="ffs" appearance="outline" subscriptSizing="dynamic">
              <input name="BeginDate" (keyup)='onDateInputkeyup($event)' formControlName="BeginDate" (dateChange)="onDateSelect($event)" [min]="minDate" placeholder="MM/DD/YYYY" matInput [matDatepicker]="startdatepicker" ngDefaultControl>
              <mat-datepicker-toggle matIconSuffix [for]="startdatepicker"></mat-datepicker-toggle>
              <mat-datepicker #startdatepicker></mat-datepicker>
              <mat-error>{{errorMessageForBeginDate}}</mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-2 right-shift">
            <label class="lbl_fld">End Date</label>
          </div>
          <div class="col-md-4">
            <mat-form-field class="ffs" appearance="outline" subscriptSizing="dynamic">
              <input name="EndDate" (keyup)='onDateInputkeyup($event)' formControlName="EndDate" (dateChange)="onDateSelect($event)" [min]="minDate" placeholder="MM/DD/YYYY" matInput [matDatepicker]="enddatepicker" ngDefaultControl>
              <mat-datepicker-toggle matIconSuffix [for]="enddatepicker"></mat-datepicker-toggle>
              <mat-datepicker #enddatepicker></mat-datepicker>
              <mat-error>{{errorMessageForEndDate}}</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row" style="padding-top: 0%;padding-bottom: 1%;">
          <div class="col-md-12" style="text-align: center;">
            <button [disabled]="(!this.form.valid || enableSearch==false)" mat-flat-button class="btn-save">Search</button>
            <button style="margin-left: 1%;" type="button" (click)="clearSearch()" mat-flat-button color="primary" class="btn-cancel">Clear</button>
          </div>
        </div>
      </div>
      </mat-expansion-panel>
    </mat-accordion>
      </form>
      <div class="store-search-row" *ngIf="dataSource!=null" style="margin-top: 1%;">
        <div class="form-group search-group" >
          <mat-form-field class="ffs" appearance="outline" style="font-size: 18px;">
            <input
              matInput
              type="text"
              (keyup)="applyFilter($event)"
              placeholder="Search"
              #input
              autocomplete="off"
            >
          </mat-form-field>
        </div>
        <div class="export-button" style="margin-right: 10%;">
          <button
            mat-raised-button
            type="button"
            class="btn-save"
            (click)="ExportToExcel()"
          >Export</button>
        </div>
      </div>
      <div id="transactionResultTable" class="mat-elevation-z8  table-container" [ngStyle]="{'height': showFilter=='Show Filter' ? '600px' : resultTableHeight }" >
          <table mat-table [dataSource]="dataSource" matSort >
      
             
              <ng-container matColumnDef="MessageID">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> Message ID </th>
                <td mat-cell *matCellDef="let element" class="table-row-font" (click)="element.RequestID!='#' && onClickTransactionId(element.RequestID,element.Initiator)" [ngClass]="{'getlink': element.RequestID!='#'}">
                  <span class="ellipsis">{{element.MessageID}}</span> 
                  <!-- {{element.MessageID}}  -->
                  </td>
              </ng-container>
      
              <ng-container matColumnDef="RelatesToMessageID">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> Relates To Message ID </th>
                <td mat-cell *matCellDef="let element" class="table-row-font"> {{element.RelatesToMessageID}} </td>
              </ng-container>
      
              <ng-container matColumnDef="PharmacyName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> Pharmacy Chain Name </th>
                <td mat-cell *matCellDef="let element" class="table-row-font"> {{element.PharmacyName}} </td>
              </ng-container>
      
              <ng-container matColumnDef="PatientLastName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> Patient Last Name </th>
                <td mat-cell *matCellDef="let element" class="table-row-font"> {{element.PatientLastName}} </td>
              </ng-container>
      
              <ng-container matColumnDef="PatientDOB">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> Patient DOB </th>
                <td mat-cell *matCellDef="let element" class="table-row-font"> {{element.PatientDOB}} </td>
              </ng-container>
      
              <ng-container matColumnDef="Species">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> Species </th>
                <td mat-cell *matCellDef="let element" class="table-row-font"> {{element.Species}} </td>
              </ng-container>
            
              <ng-container matColumnDef="MessageType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> Message Type </th>
                <td mat-cell *matCellDef="let element" class="table-row-font"> {{element.MessageType}} </td>
              </ng-container>
            
              <ng-container matColumnDef="RequestDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> Transaction Date </th>
                <td mat-cell *matCellDef="let element" class="table-row-font"> {{element.RequestDate}} </td>
              </ng-container>
              <ng-container matColumnDef="ResponseStatus">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> Transaction Status </th>
                <td mat-cell *matCellDef="let element" class="table-row-font"> {{element.ResponseStatus}} </td>
              </ng-container>
            
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator [length]="length" [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true" (page)="onPageEvent($event)"></mat-paginator>
      
          </div>
    <!-- </div> -->
  </mat-card-content>
  <br>
  <br>
</mat-card>